import { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import * as todoActions from '../../actions/authenticate';
import * as user from '../../actions/user';
import api from '../../services/api';

class AuthenticateUser extends Component {
	constructor(props) {
		super(props);
		this.authUser = this.authUser.bind(this);
	}

	componentDidMount() {
		const { authenticateUser } = this.props;
		this.removeCookies();
		this.authUser(authenticateUser);
	}

	removeCookies = () => {
		const cookies = document.cookie.split(';');

		for (let i = 0; i < cookies.length; i += 1) {
			const cookie = cookies[i];
			const eqPos = cookie.indexOf('=');
			const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
			if (name.trim() !== 'CockpitLogged' && name.trim() !== 'CockpitMenu') {
				document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;domain=.webmotors.com.br;path=/`;
			}
		}
	};

	handlerValidUser = (data) => {
		const hrefPathName = window.location.pathname;

		data.data.relationships.roles.map((role) => {
			if (role.name === 'customer') {
				return false;
			}

			if (data.data.attributes.first_access && role.name !== 'customer' && hrefPathName !== `/backoffice/usuarios/${data.data.id}`) {
				window.location.href = `/backoffice/usuarios/${data.data.id}`;
				return true;
			}

			return false;
		});
	};

	authUser = (authenticateUser) => {
		api.get('/users/me')
			.then((response) => {
				const { addDataUser } = this.props;
				authenticateUser(true);
				addDataUser(response.data.data);

				if (!localStorage.getItem('showLinkUsuarios')) {
					localStorage.removeItem('showLinkUsuarios');
					localStorage.setItem('showLinkUsuarios', true);
				}
			})
			.catch(() => {
				localStorage.removeItem('showLinkUsuarios');
				authenticateUser(false);
			});
	};

	render() {
		return null;
	}
}

const mapStateToProps = state => ({
	authenticate: state.authenticate,
	user: state.user,

});

const mapDispatchToProps = dispatch => bindActionCreators({ ...todoActions, ...user }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AuthenticateUser);
